<template>
  <v-card class="pa-8 d-flex flex-column  align-center">
    <div class="flex-grow-1" style="width: 100%">
      <h3 class="py-2">Clone Event</h3>
      <hr />
      <h4 class="mt-2">{{ event.name }}</h4>
      <div class="event-date-time">
        {{ eventTime(event.details.start) }} -
        {{ eventTime(event.details.end) }}
        <small>{{ event.details.timezone }}</small>
      </div>
      <div class="event-location">
        <a
          :href="
            `/venue/edit/${event.details.venue.id}?selectedOrgUnit=${event.details.orgUnit.id}`
          "
          >{{ event.details.venue.name }}</a
        >
        <small v-if="event.details.field" class="m1-2">
          -
          {{
            event.details.orgUnit.sport &&
              event.details.orgUnit.sport.fieldLabel + ": "
          }}
          {{ event.details.field }}</small
        >
      </div>
      <div>Reminders: {{ getEventReminderText() }}</div>

      <div class="mt-4 pa-4 mb-4">
        <v-select
          :items="teams"
          outlined
          dense
          item-text="name"
          item-value="id"
          v-model="selectedTeams"
          label="Select Teams to Clone Event"
          :multiple="true"
          return-object
        ></v-select>
        <v-checkbox
          v-model="eventReminders"
          hide-details
          dense
          label="Include Event Reminders"
        />
        <v-checkbox
          v-model="invitePlayers"
          hide-details
          dense
          label="Send Player Invites"
        />
      </div>
    </div>
    <div>
      <CommonButton
        @handleClick="$emit('cancel')"
        color="transparent"
        :label="$t('common.cancel')"
        width="100"
        customClassName="secondary--text font-weight-medium"
      />
      <CommonButton
        color="primary"
        :label="$t('common.yes')"
        width="100"
        customClassName="ml-2"
        @handleClick="clone"
      />
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import GetterTypes from "@/store/GetterTypes";
import CommonButton from "@/views/academy/common/CommonButton";
import * as moment from "moment";
import { cloneEventToTeams } from "@/helpers/api";
import { getOrgOverview } from "@/helpers/api";
import { bus } from "@/main";

export default {
  name: "CloneEventToTeamModal",
  components: { CommonButton },
  props: {
    teamId: { type: String },
    event: { type: Object }
  },
  data: () => {
    return {
      invitePlayers: false,
      eventReminders: false,
      teams: [],
      selectedTeams: []
    };
  },
  async mounted() {
    const orgOverview = await this.getOrgOverview();
    this.teams = orgOverview.teams
        .filter(t => !t.archived)
        .sort((a, b) => a.name.localeCompare(b.name));
  },
  methods: {
    async getOrgOverview() {
      return getOrgOverview(this.selectedOrg.id);
    },
    async clone() {
      bus.$emit("loadingOn");
      const body = {
        eventId: this.event.id,
        teams: this.selectedTeams.map(t => t.id),
        includeReminders: this.eventReminders,
        invitePlayers: this.invitePlayers
      };
      console.log(body);
      try {
        const resp = await cloneEventToTeams(this.teamId, body);
        if (resp.data.success) {
          bus.$emit("successSnack", resp.data.message);
          bus.$emit("refetchTeam");
          this.$emit("cancel");
        } else {
          bus.$emit("errorSnack", resp.data.message);
        }
      } catch (e) {
        bus.$emit("errorSnack", "Event could not be cloned, please try again.");
      }
      bus.$emit("loadingOff");
    },
    eventTime(time) {
      return moment(time).format(`h:mm A`);
    },
    getEventReminderText() {
      if (
        this.event.details.oneWeekReminder &&
        this.event.details.twoDayReminder
      ) {
        return "Morning-of and One Week Reminders";
      } else if (this.event.details.oneWeekReminder) {
        return "One Week Reminders";
      } else if (this.event.details.twoDayReminder) {
        return "Morning-of Reminder";
      } else {
        return "None";
      }
    }
  },
  computed: {
    ...mapGetters({ selectedOrg: GetterTypes.GET_ORGANIZATION })
  }
};
</script>

<style scoped>
.event-location a {
  font-size: 14px;
  text-decoration: none !important;
}
</style>
